module.exports = __webpack_public_path__ + "img/Dr Sze Sing Lee.87aea4a0.jpg";